import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import QueryForm from '../../QueryForm-Component/QueryForm';

const QueryFormModal = ({ show, onHide, selectedRowData, userId, onSubmitSuccess }) => {
    const nettCharge = selectedRowData?.nettCost?.toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    }) || '0.00';

    const ReadOnlyData = {
        lineID: selectedRowData?.lineId,
        siteRef: selectedRowData?.bun,
        siteName: selectedRowData?.site,
        dateOfJob: selectedRowData?.jobdate,
        attendedFrom: selectedRowData?.start,
        attendedTo: selectedRowData?.finish,
        hrsBilled: selectedRowData?.hours,
        rateBilled: selectedRowData?.charge,
        nettCharge: nettCharge,
        providerName: selectedRowData?.provider,
        roleName: selectedRowData?.role,
    };

    const UserData = {
        raisedBy: "",
        jobTitle: "",
        contactNo: "",
        raisedByEmail: userId
    };

    const submitQuery = async () => {
        onSubmitSuccess();
    };

    return (
        <Modal show={show} onHide={onHide} dialogClassName="modal-dialog-centered" className="query-modal" animation={true}>
            <Modal.Header closeButton closeVariant="white">
                <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body className="">
                <QueryForm
                    initialReadOnlyData={ReadOnlyData}
                    userData={UserData}
                    onSubmit={submitQuery}
                    updateMode={1}
                />
            </Modal.Body>
        </Modal>
    );
};

QueryFormModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    selectedRowData: PropTypes.object,
    userId: PropTypes.string,
    onSubmitSuccess: PropTypes.func.isRequired,
};

export default QueryFormModal;
